<template>
  <div>
    <Header/>
    <ImpRemember/>
    <EffectiveLearning/>
  </div>
</template>

<script>
    import Header from "./Header";
    import ImpRemember from "./ImpRemember";
    import EffectiveLearning from "./EffectiveLearning";
    export default {
        name: "Main",
      components: {EffectiveLearning, ImpRemember, Header},
      created() {
        this.$store.commit("SET_PAGE_TYPE", "alex-customize");
        this.$store.commit("SET_PAGE_FOOTER_BACKGROUND_COLOR", "#F7F7F7");
        // console.log("Background Color", this.$store.state.pageFooterBackgroundColor);
      }
    }
</script>

<style scoped>

</style>
